/**
 * @fileoverview Window-event bus for the student "My tasks" module. Lets any
 * saver notify the sidebar badge (and other listeners) that the pendency spine
 * changed, mirroring the 'ai-context-updated' pattern from NewProject.
 */

export const STUDENT_TASKS_UPDATED_EVENT = 'student-tasks-updated'

/** Announces that the student tasks spine changed (e.g. after a submission). */
export function notifyStudentTasksUpdated(): void {
  window.dispatchEvent(new Event(STUDENT_TASKS_UPDATED_EVENT))
}

/** Subscribes to spine updates; returns the unsubscribe cleanup. */
export function subscribeStudentTasksUpdated(listener: () => void): () => void {
  window.addEventListener(STUDENT_TASKS_UPDATED_EVENT, listener)
  return () => window.removeEventListener(STUDENT_TASKS_UPDATED_EVENT, listener)
}
